import { render, staticRenderFns } from "./question-details.vue?vue&type=template&id=5bac1db6&scoped=true"
import script from "./question-details.vue?vue&type=script&lang=js"
export * from "./question-details.vue?vue&type=script&lang=js"
import style0 from "./question-details.vue?vue&type=style&index=0&id=5bac1db6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bac1db6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bac1db6')) {
      api.createRecord('5bac1db6', component.options)
    } else {
      api.reload('5bac1db6', component.options)
    }
    module.hot.accept("./question-details.vue?vue&type=template&id=5bac1db6&scoped=true", function () {
      api.rerender('5bac1db6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/research/question-details.vue"
export default component.exports